import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UnMaskDirective } from './un-mask.directive';

@NgModule({
  imports: [ CommonModule ],
  declarations: [ UnMaskDirective ],
  exports: [ UnMaskDirective ]
})
export class UnMaskInputModule {}



// WEBPACK FOOTER //
// ./src/app/directives/UnMaskInput/un-mask.module.ts